//Library imports
import React, { useEffect, useState, memo } from "react";
import { Col, Row } from "antd";
import { useSelector } from "react-redux";
import store, { RootState } from "store";
import { useHistory, useLocation } from "react-router-dom";

//Local Imports
import ListCard from "modules/Campaigns/Shared/ListCard";
import AddCampaign from "modules/Campaigns/Shared/AddCampaign";
import FloatingPopover from "../../../Common/Components/FloatingPopover";
import { IListItem } from "../interface";
import InfiniteLoader from "modules/Common/Components/InfiniteLoader";
import {
  changeResetCount,
  cloneList,
  exportListDetails,
  getAudienceLists,
  getAudienceSearchedLists,
  resetAudienceListDetailsNonProfiled,
  resetAudienceListDetailsProfiled,
  resetAudienceListSearchTerm,
} from "./actions";
import AssetsCardPlaceHolder from "modules/Campaigns/AssetsWithOutCampaigns/Components/AssetsCardPlaceHolder";
import ListCardPopover from "../Components/ListCardPopover";
import { deleteAudienceList } from "./actions";
import Delete from "../../../../assets/img/icons/ArticlePopover/lowerList/Delete.svg";
import { AUDIENCE_PEOPLE } from "constants/actionTypes";
import FloatingNewListAsider from "./FloatingNewListAsider";
import ConfirmDialog from "modules/Common/Components/ConfirmDialog";
import EmptyTabInfo from "modules/Content/Shared/EmptyTabInfo";
import { getPlanType } from "utils";
import ListItem from "modules/Campaigns/Shared/ListItem";
import ListItemCustomLoader from "modules/Common/ListItemCustomLoader";
import Send from "../../../../assets/img/icons/Send.svg";
import ExportPopup from "../Components/ExportPopup";

//Style Imports
import styled from "styled-components";
import { AUDIENCE_LISTS } from "constants/types";

interface AudienceListsProps {
  setShowNewListAsider?: (arg0: boolean) => void;
  isListView?: boolean;
  setIsListView?: (arg0: boolean) => void;
  sortByFilter: number;
  setSortByFilter: (value: number) => void;
  setTabState: (value: string) => void;
  tabState?: string;
}

const DEFAULT_PAGE_LIMIT = 20;

const AudienceLists: React.FC<AudienceListsProps> = (props) => {
  //Constants
  const location = useLocation();
  const history = useHistory();
  const { isListView, tabState, setTabState } = props;

  //Redux States
  const page: number = useSelector((state: RootState) => state.audienceLists.page);
  const loading: boolean = useSelector((state: RootState) => state.audienceLists.loading);
  const lists: IListItem[] = useSelector((state: RootState) => state.audienceLists.data);
  const paginationStatus: boolean = useSelector((state: RootState) => state.audienceLists.paginationStatus);
  const searchedTerm: string = useSelector((state: RootState) => state.audienceLists.searchTerm);
  const searchTermCheck: boolean = useSelector((state: RootState) => state.audienceLists.check);
  const searchedPage: number = useSelector((state: RootState) => state.audienceLists.searchedPage);
  const searchedLoading: boolean = useSelector((state: RootState) => state.audienceLists.searchedLoading);
  const searchedLists: IListItem[] = useSelector((state: RootState) => state.audienceLists.searchData);
  const cloneListFailedCheck = useSelector((state: RootState) => state.audienceLists.cloneListFailedCheck);
  const listAudienceFilters = useSelector((state: RootState) => state.audienceLists.listAudienceFilters);
  const totalLists: number = useSelector((state: RootState) => state.audienceLists.totalLists);

  //Local States
  const [selectedList, setSelectedList] = useState(0);
  const [isSearched, setIsSearched] = useState(false);
  const [resolveRejectShowDialoge, setResolveRejectShowDialoge]: [any, any] = useState(undefined);
  const [showDeleteAssetDialoge, setShowDeleteAssetDialoge] = useState(false);
  const [showCloneListFailedMessage, setShowCloneListFailedMessage] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);

  const listClick = (listId: string) => {
    setTabState("profiled");
    resetAudienceListDetailsProfiled();
    resetAudienceListDetailsNonProfiled();
    const listDetailsUrl = `${location.pathname}${location.pathname.endsWith("/") ? "" : "/"}view${location.search
      }${location.search.length > 1 ? "&" : "?"}list_id=${listId}`;
    history.push(listDetailsUrl);
  };

  const getPagination = (isExport?: boolean) => {
    let offset = page > 0 ? lists.length : 0;
    let limit = DEFAULT_PAGE_LIMIT;
    const _params: any = { offset, limit };
    // _params["is_profiled"] = tabState;
    // _params["filter_personality"] = "";
    return _params;
  };

  const getSearchedPagination = () => {
    let offset = searchedPage > 0 ? searchedLists.length : 0;
    let limit = DEFAULT_PAGE_LIMIT;
    let list_name = searchedTerm;
    // let sort_by_filter = sortByFilter;

    return { offset, limit, list_name };
  };

  // returns a promise for future state of confirm asset deletion dialoge
  const deletePromiseFuture = async () => {
    const promiseObj = new Promise((resolve, reject) => {
      setResolveRejectShowDialoge({
        res: resolve,
        rej: reject,
      });
    });
    return promiseObj;
  };

  const onDeleteList = (listId: any) => {
    deletePromiseFuture().then((res) => {
      deleteAudienceList(listId, isSearched);
    });
  };

  const cloneListHandler = (listId: string, isSearched: boolean) => {
    cloneList(listId, isSearched);
  };

  const popoverTitleItems = (listId: string) => [
    {
      text: "Edit List",
      handler: (e: any) => {
        listClick(listId);
      },
    },
    {
      text: "Clone List",
      handler: (e: any) => {
        cloneListHandler(listId, isSearched);
      },
    },
  ];
  const popoverContentItems = (listId: string) => {
    return [
      {
        text: ` Export`,
        handler: (e: any) => {
          setSelectedList(parseInt(listId));
          exportListDetails({ export: true, ...listAudienceFilters }, parseInt(listId));
        },
        image: Send,
      },
      {
        text: ` Delete List`,
        handler: (e: any) => {
          onDeleteList(listId);
        },
        image: Delete,
      },
    ];
  };
  const popover = (listId: string) => {
    return (
      <ListCardPopover
        isTitleItemFunctional={true}
        popoverTitleItems={popoverTitleItems(listId)}
        popoverContentItems={popoverContentItems(listId)}
      />
    );
  };

  const loadMore = () => {
    if (isSearched) {
      if (!searchedLoading) getAudienceSearchedLists(getSearchedPagination());
    } else {
      if (!loading) getAudienceLists(getPagination());
    }
  };

  //Triggered when user confirms the confirm dialoge of Email Deletion
  const emailDeleteHandler = () => {
    setShowDeleteAssetDialoge(false);
    resolveRejectShowDialoge.res();
    setResolveRejectShowDialoge(undefined);
  };

  //Triggered when user cancels the confirm dialoge of Email Deletion
  const onConfirmDialogCancel = () => {
    setShowDeleteAssetDialoge(false);
    resolveRejectShowDialoge.rej();
    setResolveRejectShowDialoge(undefined);
  };

  useEffect(() => {
    if (page === 0 && !loading) {
      getAudienceLists(getPagination());
    } else if (page > 0 && !loading && lists.length < DEFAULT_PAGE_LIMIT) {
      loadMore();
    }
    return () => {
      // when component unmount reset count change and reset searchTerm
      resetAudienceListSearchTerm();
      changeResetCount();
      store.dispatch({
        type: AUDIENCE_PEOPLE.CLEAR,
      });
    };
  }, []);

  // useEffect(() => {
  //   console.log("sortBYFilter", sortByFilter);
  // }, [sortByFilter]);

  useEffect(() => {
    if (searchedTerm !== "") {
      setIsSearched(true);
      getAudienceSearchedLists(getSearchedPagination());
    } else {
      setIsSearched(false);
    }
  }, [searchedTerm, searchTermCheck]);

  useEffect(() => {
    if (resolveRejectShowDialoge && showDeleteAssetDialoge === false) {
      setShowDeleteAssetDialoge(true);
    }
  }, [resolveRejectShowDialoge]);

  useEffect(() => {
    if (!firstLoad) {
      setShowCloneListFailedMessage(true);
      setTimeout(() => {
        setShowCloneListFailedMessage(false);
      }, 3000);
    } else {
      setFirstLoad(false);
    }
  }, [cloneListFailedCheck]);

  return (
    <Wrapper>
      {showDeleteAssetDialoge && (
        <DialogWrapper>
          <div className="back-overlay" />
          <ConfirmDialog
            cancel="Cancel"
            confirm="Delete"
            onConfirm={emailDeleteHandler}
            onCancel={onConfirmDialogCancel}
            title={"Are you sure you want to delete this list?"}
            titleQuestion={null}
          />
        </DialogWrapper>
      )}
      {showCloneListFailedMessage && (
        <DialogWrapper>
          <ConfirmDialog title={"List Clone Failed"} titleQuestion={null} />
        </DialogWrapper>
      )}
      <InfiniteLoader
        dataLength={isSearched ? searchedLists.length : lists.length}
        next={loadMore}
        hasMore={isSearched ? searchedLists.length < totalLists : lists.length < totalLists}
        loader={
          isListView === true ? (
            <ListItemCustomLoader count={4} loading={isSearched ? searchedLoading : loading} />
          ) : (
            <AssetsCardPlaceHolder loading={isSearched ? searchedLoading : loading} />
          )
        }
      >
        {lists.length === 0 && !loading && !isSearched ? (
          <EmptyTabInfo description="You haven’t created or imported any list yet, please click on Import a list option. "></EmptyTabInfo>
        ) : searchedLists.length === 0 && isSearched && !searchedLoading ? (
          <EmptyTabInfo description="No list found against your search"></EmptyTabInfo>
        ) : null}
        {searchedTerm.length > 0 && searchedLoading && searchedLists.length === 0 ? (
          isListView === true ? (
            <ListItemCustomLoader count={4} loading={isSearched ? searchedLoading : loading} />
          ) : (
            <AssetsCardPlaceHolder loading={isSearched ? searchedLoading : loading} />
          )
        ) : null}
        <div id="audience-list-images">
          {lists.length === 0 && loading ? (
            isListView === true ? (
              <ListItemCustomLoader count={4} loading={isSearched ? searchedLoading : loading} />
            ) : (
              <AssetsCardPlaceHolder loading={isSearched ? searchedLoading : loading} />
            )
          ) : (
            <Row gutter={{ xs: 20, sm: 30, md: 40, lg: 40, xxl: 56 }} data-id="qa-list-wrappers">
              {isListView
                ? [...(isSearched ? searchedLists : lists)].map((item, index) => (
                  <Col key={index} className="gutter-row" span={24}>
                    <ListItem
                      key={index}
                      item={item}
                      isList={true}
                      handleOnClick={() => listClick(item.id.toString())}
                      externalPopover={() => popover(item.id.toString())}
                      setTabState={setTabState}
                    />
                  </Col>
                ))
                : [...(isSearched ? searchedLists : lists)].map((item, index) => (
                  <Col
                    key={index}
                    className="gutter-row"
                    data-id={`qa-index`}
                    xs={18}
                    sm={12}
                    md={8}
                    lg={6}
                    xl={6}
                    xxl={4}
                  >
                    <ListCard
                      key={index}
                      list={item}
                      isList={true}
                      handleOnClick={() => listClick(item.id.toString())}
                      externalPopover={() => popover(item.id.toString())}
                      setTabState={setTabState}
                    />
                  </Col>
                ))}

              {loading || searchedLoading ? null : (
                <Col className="gutter-row add-list" xs={18} sm={12} md={8} lg={6} xl={6} xxl={4}>
                  <FloatingNewListAsider idprefix="list-asider">
                    <AddCampaign />
                  </FloatingNewListAsider>
                </Col>
              )}
            </Row>
          )}
        </div>
      </InfiniteLoader>
      <ExportPopup listId={selectedList} />
    </Wrapper>
  );
};

export default memo(AudienceLists);

const Wrapper = styled.div`
  margin-top: 25px;
  /* height: 300px; */
  .add-list {
    margin-top: 85px;
    height: 150px;
  }
`;

const DialogWrapper = styled.div`
  z-index: 17;
  top: 50%;
  left: 50%;
  position: fixed;
  .back-overlay {
    position: fixed;
    background: grey;
    opacity: 0.2;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
  }
`;
